<template>
	<div
	class="pt-2 pb-2 clearfix"
	:class="containerClass"
	v-touch:tap="tapHandler"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>
		<template v-if="data">
			<p class="mb-1 mt-1 font-bold">
				{{ data.patientref}}
			</p>
			<p class="mt-0 mb-0 mb-0">{{ completeStr }}
			<template v-if="statusStr"> <span class="text-subtle">&#183;</span> {{ statusStr }}</template></p>
		</template>

		<template v-else>
			{{$t('loading')}}
		</template>


	</div>
</template>

<script>
export default {
	props: ['data', 'selectedItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		tapHandler() {
			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		}
	},
	computed: {
		selected() {
			return this.selectedItem && this.selectedItem.id == this.data.id;
		},
		containerClass() {
			const classArr = [];
			if(this.selected) {
				classArr.push('active')
			}
			return classArr.join(' ');
		},
		completeStr() {
			return this.data.complete == '1' ? this.$t('complete') : this.$t('in-progress');
		},
		statusStr() {
			return (this.data.complete == '1' && this.data.status) ? this.$t(this.data.status) : null;
		}
	}
};
</script>
